import type { ColumnsConfigType } from "app/pages/sales-intelligence/modules/enrichment/store/type";

import type { ContactsExportColumnType } from "../types/columns";

export const CONTACTS_COLUMN_CATEGORY_CONFIG: Omit<ColumnsConfigType, "fields"> = {
    labelKey: "si.components.advanced_search_results_table.column_picker.category.contacts",
    name: "contacts",
};

export const CONTACTS_COLUMNS_CONFIG: readonly ContactsExportColumnType[] = [
    { id: "emails", name: "emails", type: "regular", category: "contacts" },
    { id: "direct_phone", name: "direct_phone", type: "regular", category: "contacts" },
    { id: "mobile_phone", name: "mobile_phone", type: "regular", category: "contacts" },
    { id: "first_name", name: "first_name", type: "regular", category: "contacts" },
    { id: "last_name", name: "last_name", type: "regular", category: "contacts" },
    { id: "contact_linkedin_url", name: "contact_linkedin_url", type: "regular", category: "contacts" },
    { id: "title", name: "title", type: "regular", category: "contacts" },
    { id: "department", name: "department", type: "regular", category: "contacts" },
    { id: "seniority", name: "seniority", type: "regular", category: "contacts" },
    { id: "role", name: "role", type: "regular", category: "contacts" },
    { id: "country", name: "country", type: "regular", category: "contacts" },
];
